import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleableSection", "toggleIcon", "toggleText", "toggleButton"]

  connect() {
    this.isVisible = false
  }

  toggle() {
    this.isVisible = !this.isVisible

    const toggleableSection = document.querySelector('[data-toggle-section-target="toggleableSection"]')
    
    if (toggleableSection) {
      if (this.isVisible) {
        toggleableSection.classList.remove("d-none")
        toggleableSection.classList.add("fade-in")
      } else {
        toggleableSection.classList.add("d-none")
        toggleableSection.classList.remove("fade-in")
      }
    }

    // Update button appearance
    this.updateButtonAppearance()
  }

  updateButtonAppearance() {
    if (this.hasToggleIconTarget) {
      if (this.isVisible) {
        this.toggleIconTarget.classList.remove("fa-chevron-down")
        this.toggleIconTarget.classList.add("fa-chevron-up")
      } else {
        this.toggleIconTarget.classList.remove("fa-chevron-up")
        this.toggleIconTarget.classList.add("fa-chevron-down")
      }
    }

    if (this.hasToggleTextTarget) {
      this.toggleTextTarget.textContent = this.isVisible ? "Hide Role Breakdown" : "Show Role Breakdown"
    }

    if (this.hasToggleButtonTarget) {
      if (this.isVisible) {
        this.toggleButtonTarget.classList.remove("btn-outline-primary")
        this.toggleButtonTarget.classList.add("btn-primary")
      } else {
        this.toggleButtonTarget.classList.remove("btn-primary")
        this.toggleButtonTarget.classList.add("btn-outline-primary")
      }
    }
  }
}
